import { auth, redirectIfAuthenticated, redirectIfWrongType } from './utils.routing'
import { ticketSellerRouteNames } from './routeNames/ticketSellerRouteNames'
import { ticketSellerAdminRouteNames } from './routeNames/ticketSellerAdminRouteNames'
import { ungroupedRouteNames } from './routeNames/ungroupedRouteNames'
import { organizerRouteNames, organizationRouteNames } from './routeNames/organizerRouteNames'
import { sharedRouteNames } from './routeNames/sharedRouteNames'
import { mainRouteNames } from './routeNames/mainRouteNames'
import { adminRouteNames } from './routeNames/adminRouteNames'

import Vue from 'vue'
import Router from 'vue-router'
import MainNavigator from '../components/shared/MainNavigator.vue'
import { MainRoutes } from './routes/main-routes'
import { UngroupedRoutes } from './routes/ungrouped-routes'
import {
  theaterOrganizationRouteNames,
  theaterOrganizerRouteNames,
} from '@/routing/routeNames/theaterOrganizerRouterNames'
import {
  sportOrganizationRouteNames,
  sportOrganizerRouteNames,
} from '@/routing/routeNames/sportOrganizerRouteNames'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err && err.name === 'NavigationDuplicated') return err
    if (err && err.message && err.message.includes('Redirected')) return err
    throw err
  })
}

export const router = new Router({
  mode: 'history',
  routes: [
    ...UngroupedRoutes,
    {
      path: '/',
      component: MainNavigator,
      meta: {
        requiresAuthentication: false,
        redirectIfAuthenticated: false,
      },
      children: MainRoutes,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.fullPath.substr(0, 2) === '/#') {
    const path = to.fullPath.substr(2)
    next(path)

    return
  }
  next()
})

router.afterEach(to => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'pageview',
      page: to.fullPath,
    })
  }
})

router.beforeEach(auth)
// TODO: refactor this two methods below
router.beforeEach(redirectIfAuthenticated)
router.beforeEach(redirectIfWrongType)

// WHEN REMOVING/ADDING MIXINS REMEMBER TO ALSO REMOVE/ADD THEM IN "global.d.ts" !!

Vue.mixin({
  data() {
    return {
      routes: {
        organizer: organizerRouteNames,
        organization: organizationRouteNames,
        theaterOrganization: theaterOrganizationRouteNames,
        theaterOrganizer: theaterOrganizerRouteNames,
        sportOrganization: sportOrganizationRouteNames,
        sportOrganizer: sportOrganizerRouteNames,
        admin: adminRouteNames,
        ticketSeller: ticketSellerRouteNames,
        ticketSellerAdmin: ticketSellerAdminRouteNames,
        main: mainRouteNames,
        shared: sharedRouteNames,
        ungrouped: ungroupedRouteNames,
      },
    }
  },
  mounted() {
    // A static list avoids invalidating a live collection on every class change.
    const vIcon = document.querySelectorAll('.v-icon:not(.notranslate)')
    for (let i = 0; i < vIcon.length; i++) {
      vIcon[i].classList.add('notranslate')
    }
  },
  methods: {
    goBack() {
      const { length } = window.history
      if (length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },
    goTo(name, params) {
      router.push({ name, params })
    },
  },
})
